module.exports = __webpack_public_path__ + "img/logo-CNA-big.873a570a.png";